<template>
  <div>
    <van-popover class="w-full" :value="visible" trigger="click" placement="bottom-start">
      <ul class="select-group pt-2">
        <li v-for="item in selectList" :key="item" class="select-item" @click="onSelect(item)">
          <div>
            <span>{{ item }}</span>
          </div>
        </li>
      </ul>
      <template v-slot:reference>
        <van-field
            ref="field"
            @focus="onFocus"
            :placeholder="placeholderValue"
            :type="type"
            :value="value"
            v-bind="$attrs"
            @input="onInput"
            @change="onChange"
            @blur="onBlur"
            clearable
            @clear="onClear"
            @copy.native="onCopy"
            @paste.native="onPaste"
            @cut.native="onCut"
        >
          <template v-slot:left-icon v-if="prefixIcon">
            <van-icon class-prefix="icomoon" :name="prefixIcon"></van-icon>
          </template>
          <template v-slot:button>
            <slot name="button"></slot>
          </template>
        </van-field>
      </template>
    </van-popover>
    <div v-if="showErrorTip" class="mt-2 p-2 danger-box text-medium">
      {{ errorTip }}
    </div>
  </div>
</template>

<script>
import { getHistoryQuestionAnswer, getTextFillErrorTip } from 'dygc'
import { Notify } from 'vant'

export default {
  name: 'RelationInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    questionId: {
      type: String,
      default: ''
    },
    optionId: {
      type: String,
      default: ''
    },
    questionType: {
      type: Number
    },
    enableRelation: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    prefixIcon: {
      type: String,
      default: ''
    },
    disableCopy: {
      type: Boolean,
      default: false
    },
    minLength: {
      type: Number,
      default: -1
    },
    maxLength: {
      type: Number,
      default: -1
    },
    validate: {
      type: String,
      default: null
    },
    enabledErrorTip:{
      type:Boolean,
      default:true
    },
    allowErrorList:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      visible: false,
      selectList: []
    }
  },
  computed: {
    placeholderValue() {
      if (this.placeholder) return this.placeholder
      return '请输入'
    },
    showErrorTip() {
      if(!this.enabledErrorTip) return false
      return !!this.errorTip.length
    },
    errorTip() {
      if(!this.value) return ''
      if(this.allowErrorList.includes(this.value.toString().trim())) return ''
      return getTextFillErrorTip(this.value, {
        maxLength: this.maxLength,
        minLength: this.minLength,
        validate: this.validate
      })
    },
  },
  methods: {
    onCopy(evt) {
      if (this.disableCopy) {
        evt.preventDefault()
        Notify({
          type: 'warning',
          message: '禁止复制粘贴'
        })
        return false
      }
    },
    onPaste(evt) {
      if (this.disableCopy) {
        evt.preventDefault()
        Notify({
          type: 'warning',
          message: '禁止复制粘贴'
        })
        return false
      }
    },
    onCut(evt) {
      if (this.disableCopy) {
        evt.preventDefault()
        Notify({
          type: 'warning',
          message: '禁止复制粘贴'
        })
        return false
      }
    },
    onSelect(item) {
      this.$emit('input', item)
      this.visible = false
    },
    onInput(event) {
      this.$emit('input', event)
    },
    onBlur() {
      this.visible = false
    },
    onClear() {
      this.visible = false
    },
    onChange(e) {
      this.$emit('change', e)
    },
    onFocus() {
      if (!this.enableRelation) return
      this.$nextTick(() => {
        this.visible = true
      })
    },
    searchHandler(val) {
      const tmp = (this.tmp = Math.random() * 100000)
      getHistoryQuestionAnswer({
        surveyId: this.$bus.survey.id,
        questionId: this.questionId,
        questionType: this.questionType,
        optionId: this.optionId,
        keyWord: val
      }).then(res => {
        if (tmp !== this.tmp) return
        this.selectList = res.data
      })
    },
    onOpenPopover() {},
    onClosePopover() {}
  },
  watch: {
    value(val) {
      if (val) {
        if (this.$bus.params.isTest) {
          this.$nextTick(() => {
            const removeIcons = this.$el.getElementsByClassName('van-icon-clear')
            if (!removeIcons.length) return
            const clear = this.$refs.field.onClear
            for (let i = 0; i < removeIcons.length; i++) {
              const removeIcon = removeIcons[i]
              removeIcon.removeEventListener('mousedown', clear)
              removeIcon.addEventListener('mousedown', clear)
            }
          })
        }
      }
      if (!this.enableRelation) return
      if (!val.trim()) {
        this.selectList = []
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.searchHandler(val)
      }, 200)
    }
  }
}
</script>
